import React from 'react';
import { Pagination } from 'antd';
import { cn } from './_cn';

const alignClass = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
};

const TWPagination = ({
  showSizeChanger = false,
  size = 'default',
  align = 'between',
  className = '',
  wrapperClassName = '',
  ...rest
}) => (
  <div className={cn('flex w-full items-center', alignClass[align] || alignClass.between, wrapperClassName)}>
    <Pagination
      showSizeChanger={showSizeChanger}
      size={size}
      className={cn('tw-pagination', className)}
      {...rest}
    />
  </div>
);

export default TWPagination;
